export default class Post {
    constructor(titles,bodies,categories,image) {
        this.titles = titles;
        this.bodies = bodies;
        this.categories = categories;
        this.image = image;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.bodies)) { if(!value) { result = false; break; }; }

        if(result) result = this.image && this.categories && this.categories.length;
        
        return result;
    }
}